import Stack from "@mui/material/Stack";
import { theme } from "@polifonia/theme";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { InfoBox } from "@/components/InfoBox";
import { MotifIcon } from "@/components/MotifIcon";

interface WccsActivationProps {
  webChatModuleEnabled?: boolean | undefined;
  webTrackingEnabled?: boolean | undefined;
}

export const WccsActivation: FC<WccsActivationProps> = ({
  webChatModuleEnabled = false,
  webTrackingEnabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <Stack spacing="4px">
      {webTrackingEnabled ? (
        <InfoBox
          variant="success"
          icon={
            <MotifIcon
              un-i-motif="circle_check"
              style={{
                fontSize: 16,
                color: theme.colors.staticFgPositive,
              }}
            />
          }
          description={t("channels.wccs.activation.webTracking")}
          transparent
        />
      ) : null}
      {webChatModuleEnabled ? (
        <InfoBox
          variant="success"
          icon={
            <MotifIcon
              un-i-motif="circle_check"
              style={{
                fontSize: 16,
                color: theme.colors.staticFgPositive,
              }}
            />
          }
          description={t("channels.wccs.activation.webChatModule")}
          transparent
        />
      ) : null}
    </Stack>
  );
};
